import type { SourceProviderEnum } from '@salescore/client-api'

// eslint-disable-next-line sonarjs/todo-tag
// TODO
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export const ProviderLogo = ({ provider, width }: { provider: SourceProviderEnum | string; width?: number }) => (
  <img width={width ?? 100} src={`/images/provider/${provider}.png`} />
)
